import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { useAnalyticsService } from '@/app/providers/analytics-service/hooks';

import { usePlayGame } from '@/entities/game/hooks/use-play-game';

import {
  LogDevMessageKinds,
  makeLogDevMessage,
} from '@/shared/helpers/make-log-dev-message';
import { useShare } from '@/shared/hooks/use-share/use-share';
import { mainPageLoadEvent } from '@/shared/services/analytics/events/main-page-load-event';
import { useStartappArgs, useTgActions } from '@/shared/store/tg-store/tg-store';

export const useStartAppArgsManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const analyticsService = useAnalyticsService();
  const logInfo = makeLogDevMessage<string>(
    LogDevMessageKinds.info,
    (message) => message
  );
  const playGame = usePlayGame();

  const startAppArgs = useStartappArgs();
  const { updateStartappArgs } = useTgActions();

  const removeStartAppFromPath = () => {
    if (searchParams.has('startapp')) {
      searchParams.delete('startapp');
      setSearchParams(searchParams, { replace: true });
    }
  };

  const shareGame = useShare('deep_link', 'GAME');
  const shareReferral = useShare('deep_link', 'REFERRAL');

  const clearStartAppArgs = () => {
    setTimeout(() => {
      updateStartappArgs({ path: null, gameKey: undefined });

      removeStartAppFromPath();
    }, 1000);
  };

  useEffect(() => {
    const { path, src, gameKey } = startAppArgs ?? {};

    // Костыль для нового шаринга из пуша через /sharing
    // /sharing просто помогает запустить красивый шаринг, не является реальным путем
    if (path === '/sharing') {
      logInfo('Запуск красивого шаринга для /sharing');
      try {
        // Запускаем красивый шаринг через useShare
        if (gameKey) {
          void shareGame({ gameKey });
        } else {
          void shareReferral();
        }
      } catch (err) {
        logInfo(`Ошибка при вызове красивого шаринга: ${err}`);
      }

      clearStartAppArgs();
      return;
    }

    // фоллбэк для мета игры, чтобы путь на неё открывал игру.
    // todo: удалить через месяца 2
    if (path === '/meta-game') {
      void playGame(
        {
          key: '0gM1yV1Fhe',
          title: 'Snowbucks',
          gameUrl: 'https://t.me/snowbucks_bot/game',
          flags: { bot: true },
        },
        'meta-game-page'
      );

      clearStartAppArgs();
      return;
    }

    if (path) {
      logInfo(`navigate to path: ${path}`);
      const state: Record<string, any> = { source: src };

      navigate(path, { state });

      updateStartappArgs({ path: null });
    } else {
      // Send main page event only if initial page is main or no path specified
      const initEvent = mainPageLoadEvent(location.state?.source ?? src);
      analyticsService.send(initEvent);
    }

    removeStartAppFromPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Зависимости намеренно не указаны, чтобы эффект выполнился один раз при монтировании
};
